<template>
  <ul>
    <li v-for="label in data" class="label"  v-bind:class="{'invalid' : !label.valid }" >
      <span class="summary" v-bind:style="{ color: label.summaryColor }">
        <span class="type" v-bind:style="{ color: label.typeColor, backgroundColor:  label.typeBgColor}" >{{label.type}}</span>
        <span v-if="label.summary">{{label.summary}}</span>
      </span>
      <span v-if="label.count" class="count">x{{label.count}}</span>
    </li>
  </ul>
</template>


<script>
  export default {
    name: 'labels',
    props: ['data'],
    data () {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?672514f1